import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import { getQueryString } from './utils/utils'

import VueRouter from "vue-router";
import {
	routes
} from "./router";

Vue.use(VueRouter);
const router = new VueRouter({
	routes,
	mode: "history",
    base: process.env.VUE_APP_BASE_URL,
});

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

const ENV_DATA = process.env.VUE_APP_ENV_DATA
const envData = JSON.parse(ENV_DATA)
// console.log('envData', envData);
Vue.prototype.$envData = envData


Vue.prototype.$http = axios;
axios.interceptors.response.use(response => {
    return response.data;
}, (err) => { // 这里是返回状态码不为200时候的错误处理
    const data = err.response
    const rr = getQueryString('redirect_uri')

    switch (data.status) {
        case 401:
            // 未登录 清除已登录状态
            if(rr){
                router.push('/index?callback=' + rr);
            }else{
                router.push('/');
            }
            break;
        case 403:
            // 没有权限
            break;
        case 500:
            // 错误
            break;
    }
    return err.response.data;
});


// axios.defaults.baseURL='http://172.16.1.222:30016'

// 设置默认请求头
axios.defaults.headers.common["service"] = "sso";
axios.defaults.headers.common["Content-Type"] = "application/json";


// 列表无缝滚动
import scroll from "vue-seamless-scroll";
Vue.use(scroll);

import moment from "moment";
Vue.use(moment);
moment.locale('zh-cn')

new Vue({
	router,
	render: (h) => h(App),
}).$mount("#app");
